<template>
  <div>
    <b-modal
      title="查詢設定自動扣款資料"
      size="xl"
      centered
      hide-footer
      header-class="head-modal"
      v-model="modalShow"
    >
      <div v-if="mode === 'contract'" class="operate">
        <div class="search">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="類型">
            <b-form-select
              v-model="search.type"
              :options="options.type" />
          </b-form-group>

          <b-form-group label-cols="auto" label-cols-lg="auto" label="要助人郵局帳號">
            <b-form-input v-model="search.pay_bank_account"></b-form-input>
          </b-form-group>

          <b-form-group label-cols="auto" label-cols-lg="auto" label="要助人身分證">
            <b-form-input v-model="search.pay_ID_number"></b-form-input>
          </b-form-group>
        </div>

        <div class="btn-area">
          <div class="btn-function">
            <b-button variant="danger" @click="resetSearch()">重置</b-button>

            <b-button variant="success" @click="getSetAutoApply()">搜尋</b-button>
          </div>
        </div>
      </div>

      <div v-else-if="mode === 'bill'">
        <div class="text-right">
          <b-button
            class="mb-2"
            variant="secondary"
            size="sm"
            @click="generatePostOfficeTransferCollection()"
          >
            委託郵局媒體轉帳代收總數表PDF
          </b-button>
        </div>


        <tables-page
          :tableData="data.table_data"
          :tableFields="data.table_fields"
        ></tables-page>
      </div>

      <div
        class="main"
        @click="copyToClipboard"
        v-b-tooltip.hover title="點擊複製"
      >
        <pre
          v-for="(item, index) in autoApplyData"
          :key="index"
          class="pre-text"
        >{{ item }}</pre>
      </div>

      <b-overlay :show="status.isLoading" no-wrap></b-overlay>
    </b-modal>

    <html-to-pdf
      v-if="status.resetDom"
      ref="htmlToPdf"
      @handlerCompleted="pdfCompleted"
    >
      <template slot="pdf-content">
        <post-office-transfer-collection :data="data.temp_table_data" />
      </template>
    </html-to-pdf>
  </div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import contractApi from "@/models/API/contractApi";
import billApi from "@/models/API/billApi";
import PostOfficeTransferCollection from '@/components/common/PrintTemplate/PostOfficeTransferCollection';
import HtmlToPdf from '@/components/common/HtmlToPdf';

export default {
  name: 'SetAutoApplyModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    mode: {
      type: String,
      required: false,
      default: 'contract'
    },
  },
  components: {
    TablesPage,
    PostOfficeTransferCollection,
    HtmlToPdf
  },
  data () {
    return {
      options: {
        type: [
          { value: 1, text: '申請' },
          { value: 2, text: '取消' },
        ],
      },
      status: {
        isLoading: false,
        resetDom: false
      },
      search: {
        type: 1,
        pay_bank_account: '',
        pay_ID_number: ''
      },
      autoApplyData: [],
      data: {
        table_data: [],
        table_fields: [
          {
            key: "date",
            label: "轉帳日期",
          },
          {
            key: "count",
            label: "總件數"
          },
          {
            key: "sum",
            label: "總金額"
          },
        ],
        temp_table_data: {}
       }
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue && this.mode === 'bill') this.getSetAutoBill();
      },
      immediate: false
    }
  },
  mounted() {
    this.contractApi = new contractApi();
    this.billApi = new billApi();
  },
  methods: {
    // 查詢設定自動扣款資料(契約)
    getSetAutoApply() {
      if (this.verifyRequired()) {
        this.status.isLoading = true;

        const params = {
          ...this.search,
        };

        this.contractApi.getSetAutoApply((response) => {
          const res = response.data;

          this.autoApplyData = res.data;
          this.status.isLoading = false;
        }, params, false)
      }
    },
    // 查詢設定自動扣款資料(帳單)
    getSetAutoBill() {
      this.status.isLoading = true;

      this.billApi.getSetAutoBill((response) => {
        const res = response.data;

        this.autoApplyData = res.data;
        this.data.table_data = [res];
        this.status.isLoading = false;
      }, false)
    },
    // 驗證必填
    verifyRequired() {
      try {
        let required =
          ['type',
          'pay_bank_account',
          'pay_ID_number',
          ];

        const data = this.search;
        const status = required.every(item => {
          return Array.isArray(data[item]) ? data[item].length !== 0 : data[item] != null && data[item] !== '';
        });

        if (!status) {
          throw { message: '欄位請填寫完整', title: '查詢設定自動扣款資料' };
        }

        return true;
      } catch(message) {
        this.contractApi.toast(() => {}, message, false);

        return false;
      }
    },
    // 重置欄位，並搜尋
    resetSearch() {
      this.search = {
        type: 1,
        pay_bank_account: '',
        pay_ID_number: ''
      }

      this.autoApplyData = [];
    },
    // 複製文字
    copyToClipboard() {
      const textToCopy = this.autoApplyData.join('\n'); // 將所有項目合併為一個字符串，每個項目之間用換行符分隔

      if (navigator.clipboard) { // 如果正常的剪貼方法可用，則使用它
        navigator.clipboard.writeText(textToCopy).then(() => {
          const result = { message: '複製成功', title: '查詢設定自動扣款資料' };

          this.contractApi.toast(() => {}, result, true);
        }).catch(err => {
          console.error('Failed to copy text: ', err);
        });
      } else { // 否則使用上面的函數
        this.unsecuredCopyToClipboard(textToCopy);
      }
    },
    // 無法使用navigator，則使用下列方法複製文字
    unsecuredCopyToClipboard(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      // 阻止 focusin 事件的冒泡
      textArea.addEventListener('focusin', e => e.stopPropagation());
      // 使用 CSS 隱藏文本區域
      textArea.style.position = 'fixed';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
          document.execCommand('copy');

          const result = { message: '複製成功', title: '查詢設定自動扣款資料' };

          this.contractApi.toast(() => {}, result, true);
      } catch (err) {
          console.error('Unable to copy to clipboard', err);
      }
    },
    // 產生委託郵局媒體轉帳代收總數表
    async generatePostOfficeTransferCollection() {
      this.status.resetDom = true;

      this.data.temp_table_data = Object.assign({}, this.data.table_data[0]);

      await this.$nextTick(); // 等待當前更新週期結束

      this.$refs.htmlToPdf.generatePdf();
    },
    // PDF產生完成
    pdfCompleted () {
      this.$set(this.status, 'resetDom', false);
      this.$forceUpdate();
    },
  }
}
</script>

<style lang="scss" scoped>
.operate {
  display: flex;
  white-space: nowrap;
  margin-bottom: 20px;
  column-gap: 20px;
  .search {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    flex-basis: 80%;
    .blur {
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 10px;
      .blur-info {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 50%;
        font-size: 12px;
        background: #17A2B8;
        color: #FFF;
      }
    }
  }
  .btn-area {
    flex-basis: 20%;
    .btn-function {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;

    }
  }
}
.main {
  cursor: pointer;
  user-select: none;
  .pre-text {
    display: table; /* 使背景顏色只應用於文字內容 */
    background-color: #f0f0f0; /* 設置背景顏色 */
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/modal/SetAutoApplyModal.vue